@let view = data();
@let items = sliderViews();

@if (view.headline) {
  <h2>{{ view.headline }}</h2>
}

@if (isSingleBanner()) {
  <ng-container *ngComponentOutlet="items[0].component; inputs: { data: items[0].data }"></ng-container>
} @else {
  <ui-slider
    [autoplay]="view.options.autoplay"
    [duration]="view.options.duration"
    [navigation]="view.options.navigation && view.items.length > 1"
    [ngClass]="[view.category, 'size-' + view.size]"
    [responsive]="view.category === 'banner'"
  >
    @for (item of items; track item) {
      <div uiSliderSlide>
        <ng-container *ngComponentOutlet="item.component; inputs: { data: item.data }"></ng-container>
      </div>
    }
  </ui-slider>
}
